import { showToast } from 'shared/notifications';

export const noAccessErrorHandler = (message: string) => {
  showToast({
    type: 'error',
    title: 'Отказано',
    subTitle: message ?? 'Недостаточно прав доступа'
  });
};
